export function renderWebhookEventsBarrelImportsTemplate({
  namespaceAlias,
  extractImports,
  entries
}: {
  namespaceAlias: string
  extractImports: string
  entries: string
}): string {
  return `import type { WebhookEventSource } from '${namespaceAlias}/types/webhooks'${extractImports}

export type { WebhookEventSource } from '${namespaceAlias}/types/webhooks'

export const webhookEventSources: WebhookEventSource[] = ${entries}
`
}
